import type React from 'react';
import { Box } from 'braid-design-system';
import { vars } from 'braid-design-system/css';

interface Props {
  id: number;
  active?: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>, chunkIndex: number) => void;
}

export const PaginationButton = ({ active = false, onClick, id }: Props) => (
  <Box
    onClick={(e) =>
      !active && onClick(e as React.MouseEvent<HTMLButtonElement>, id)
    }
    padding="xxsmall"
    style={{ cursor: 'pointer !important' }}
  >
    <Box
      borderRadius="full"
      background={active ? 'neutral' : undefined}
      style={{
        width: '8px',
        height: '8px',
        border: `1px solid ${vars.borderColor.neutral}`,
      }}
    />
  </Box>
);
